import React, {Dispatch, SetStateAction} from "react"
import {Grid, Modal} from "semantic-ui-react"
import {FormattedMessage, useIntl} from "react-intl"


type HowitworksGedcomProps = {
    setContactModalOpen: Dispatch<SetStateAction<boolean>>
    onClose: () => void
}


export const HowitworksGedcom = ({ setContactModalOpen, onClose }: HowitworksGedcomProps) => {
    const intl = useIntl()
    return (
        <>
            <Modal.Header>
                <h1><FormattedMessage id="howitworks.gedcom.header" values={{
                    gedcom: <span>GEDCOM</span>
                }}/></h1>
            </Modal.Header>

            <Modal.Content className="howitworks-gedcom">
                <p><FormattedMessage id="howitworks.gedcom.about" values={{
                    individuals: <span style={{ color: "var(--creator-indi-yellow-active)", fontWeight: "bold", fontSize: 17 }}>
                        {(intl.formatMessage({id: "creator.tabs.individuals"})).toLowerCase()}
                    </span>,
                    families: <span style={{ color: "var(--creator-fam-teal-active)", fontWeight: "bold", fontSize: 17 }}>
                        {(intl.formatMessage({id: "creator.tabs.families"})).toLowerCase()}
                    </span>
                }}/></p>

                {/* GEDCOM entities */}
                <Grid columns={2} divided>
                    <Grid.Row>
                        <Grid.Column className="col1">
                            <p><FormattedMessage id="howitworks.gedcom.col1" values={{
                                ancestors: <span style={{fontWeight: "bold", fontSize: 17}}>
                                    <FormattedMessage id="howitworks.gedcom.col1.ancestors"/>
                                </span>
                            }}/></p>
                            <img src={`/assets/howitworks/${intl.locale}/gedcom/individuals.svg`} alt="GEDCOM individuals"/>
                        </Grid.Column>
                        <Grid.Column className="col2">
                            <p><FormattedMessage id="howitworks.gedcom.col2" values={{
                                descendants: <span style={{ fontWeight: "bold", fontSize: 17 }}>
                                    <FormattedMessage id="howitworks.gedcom.col2.descendants"/>
                                </span>
                            }}/></p>
                            <img src={`/assets/howitworks/${intl.locale}/gedcom/families.svg`} alt="GEDCOM families"/>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

                {/* Puzzle */}
                <p className="puzzle"><FormattedMessage id="howitworks.gedcom.puzzle" values={{
                    puzzle: "🧩",
                    vertically: <span style={{ fontWeight: "bold", fontSize: 17 }}>
                        <FormattedMessage id="howitworks.gedcom.puzzle.vertically"/>
                    </span>,
                    horizontally: <span style={{ fontWeight: "bold", fontSize: 17 }}>
                        <FormattedMessage id="howitworks.gedcom.puzzle.horizontally"/>
                    </span>
                }}/></p>
                <p><FormattedMessage id="howitworks.gedcom.consistency" values={{ break: <br/> }}/></p>

            </Modal.Content>
        </>
    )
}